import {AvatarGroup as NextUIAvatarGroup, AvatarGroupProps as NextUIAvatarGroupProps} from "@heroui/react";

export interface AvatarGroupProps extends NextUIAvatarGroupProps {}

export const AvatarGroup = ({children, ...props}: AvatarGroupProps) => {
  return (
    <NextUIAvatarGroup {...props}>
      {children}
    </NextUIAvatarGroup>
  )
}